import type {
  CartUpsellThumbnailOfType,
  CartUpsellThumbnailType,
} from '../../cartUpsells.types'
import { TileBeforeAfterThumbnail } from './TileBeforeAfterThumbnail'

const CART_UPSELL_THUMBNAILS: {
  [Type in CartUpsellThumbnailType]: React.ComponentType<{
    thumbnail: CartUpsellThumbnailOfType<Type>
  }>
} = {
  'tile-before-after': TileBeforeAfterThumbnail,
}

export function CartUpsellCardThumbnail<Type extends CartUpsellThumbnailType>({
  thumbnail,
}: {
  thumbnail: CartUpsellThumbnailOfType<Type>
}) {
  // The annotation is what lets TS correlate `thumbnail.type` with its component, without a cast.
  const Thumbnail: React.ComponentType<{
    thumbnail: CartUpsellThumbnailOfType<Type>
  }> = CART_UPSELL_THUMBNAILS[thumbnail.type]
  return <Thumbnail thumbnail={thumbnail} />
}
